// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalHeader_root__3aQKU","heading":"ModalHeader_heading__23AdX"};